<template lang="pug">
  .modal-card
    header.modal-card-head
      p.modal-card-title 
        b {{$t('forgot_password.title')}}
    section.modal-card-body
      div(v-if="!success")
        div.notification.is-danger(v-show="failed") {{$t('forgot_password.invalid_email')}}
        form(v-on:submit.prevent="submit")
          b-field(:label="$t('forgot_password.email_label')" :type="errors.has('email') ? 'is-danger': ''" :message="errors.has('email') ? errors.first('email') : ''")
            b-input(type="email" ref="emailInput" v-validate="'required|email'" :placeholder="$t('forgot_password.email_placeholder')" icon="email-outline" v-model="email" name="email")
          button.is-hidden(type="submit") {{$t('forgot_password.actions.submit')}}
      div(v-else)
        .hero
          .hero-body
            p.has-text-centered
              span.icon.is-large.has-text-success
                i.mdi.mdi-email-outline.mdi-48px
            h1.title.is-3.has-text-centered {{$t('forgot_password.check_inbox_title')}}
            h3.subtitle.is-5.has-text-centered {{$t('forgot_password.check_inbox_subtitle', {email})}}
    footer.modal-card-foot
      .buttons
          action-button( :loading="loading" @click="submit" v-if="!success" title="forgot_password.actions.reset") 
          button.button(type="button" @click="cancel") {{$t('forgot_password.actions.close')}}
</template>

<script>
import AuthApi from '@/api/auth'

export default {
  name: 'ForgetPasswordForm',
  data() {
    return {
      email: undefined,
      success: false,
      failed: false,
      loading: false
    }
  },
  mounted() {
    this.$refs.emailInput.focus()
  },
  methods: {
    async submit() {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.loading = true
      try {
        await AuthApi.requestPasswordReset({email: this.email})
        this.success = true
      } catch (error) {
        this.failed = true
      }
      this.loading = false
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>
